import { useEffect, useState } from 'react'

export type Route = 'home' | 'keyword-tool' | 'resources' | 'guide' | 'login'

function currentRoute(): Route {
  const path = window.location.hash.replace(/^#\/?/, '')
  if (path === 'keyword-tool' || path === 'resources' || path === 'guide' || path === 'login') return path
  return 'home'
}

export function navigate(route: Route) {
  window.location.hash = route === 'home' ? '#/' : `#/${route}`
}

export function useHashRoute() {
  const [route, setRoute] = useState<Route>(currentRoute)

  useEffect(() => {
    const update = () => setRoute(currentRoute())
    window.addEventListener('hashchange', update)
    return () => window.removeEventListener('hashchange', update)
  }, [])

  return route
}
